import { BASE } from '~/api/fetch-client'

type CoverArtType = 'artists' | 'albums' | 'tracks'

interface CoverArtUrlForOptions {
  type: CoverArtType
  id: number | string
  /** The entity's own coverArt value. Omit when unknown; pass it when you have it. */
  coverArt?: string | null
  size?: number
}

export function coverArtUrl(type: CoverArtType, id: number | string, size?: number): string {
  const params = size ? `?size=${size}` : ''
  return `${BASE}/${type}/${id}/cover-art${params}`
}

/**
 * The single place that decides whether an entity has cover art to request.
 * Returns null when it does not, so callers render a fallback instead of
 * fetching. Use this rather than calling coverArtUrl directly.
 *
 * Two independent guards, both load-bearing:
 * - `coverArt === null` catches DJ breaks, which carry a real interstitial id
 *   that collides with whichever unrelated track happens to hold that id.
 * - `!id` catches the id-0 sentinel those same synthetic items use for
 *   artistId/albumId.
 */
export function coverArtUrlFor({ type, id, coverArt, size }: CoverArtUrlForOptions): string | null {
  if (!id || coverArt === null) return null
  return coverArtUrl(type, id, size)
}

export function streamUrl(trackId: number | string): string {
  return `${BASE}/tracks/${trackId}/stream`
}

export function artistImageUrl(artist: {
  largeImageUrl?: string | null
  mediumImageUrl?: string | null
  smallImageUrl?: string | null
  id: number
}): string | null {
  return artist.largeImageUrl || artist.mediumImageUrl || artist.smallImageUrl || null
}
